/* eslint-disable no-loop-func */
import React, { useEffect, useRef, useState } from "react";
import { toast } from "../../components/ui/use-toast";
import * as XLSX from "xlsx";
import cellEditFactory from "react-bootstrap-table2-editor";
import { Type } from "react-bootstrap-table2-editor";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import Spin from "../../components/Spin";
import {
  API,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "../../components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import FileUpload from "../../components/FileUpload";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { ExcelDateFormat } from "../../lib/Misc";
import moment from "moment";

const UploadBankTransaction = ({
  fetchAccountData,
  trustId,
  ButtonName,
  setLoading,
}) => {
  const [showImport, setShowImport] = useState(false);
  const [files, setFiles] = useState([]);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelAccountData, setExcelAccountData] = useState();
  const [isImportLoading, setIsImportLoading] = useState(false);
  // const [accountingList, setAccountingList] = useState([]);

  // const getAccounts = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await get(
  //       `${API.GET_ACCOUNTS}?trust_id=${trustId ? trustId : ""}`
  //     );
  //     const account =
  //       data?.data &&
  //       data?.data?.length > 0 &&
  //       data?.data?.map((item) => {
  //         return {
  //           label: `${item?.provider?.providerName} (${item?.accountNumber}) - ${item?.container}`,
  //           value: item?.id,
  //         };
  //       });

  //     account.unshift({ label: "Select Account" });
  //     setAccountingList(account ? account : []);

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // }, [setLoading, trustId]);

  // useEffect(() => {
  //   getAccounts();
  // }, [getAccounts]);

  // const typeList = [
  //   { label: "Select Type", value: "Select Type" },
  //   { label: "Debit", value: "Debit", excelData: "d", base_type: 0 },
  //   { label: "Credit", value: "Credit", excelData: "c", base_type: 1 },
  // ];

  // const handleDownload = async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await get(API.DOWNLOAD_BANK_STATEMENT_TEMPLATE);
  //     const export_report_path = data?.data?.file;
  //     if (export_report_path) {
  //       var a = document.createElement("a");
  //       a.href = export_report_path;
  //       var file = export_report_path.split("/");
  //       a.setAttribute("target", "_blank");
  //       a.setAttribute(
  //         "download",
  //         file[file.length - 1] || "chart-of-account.xls"
  //       );
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //       setLoading(false);
  //     }
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  // };

  const handleDownload = async () => {
    try {
      setLoading(true);
      const { data } = await get(API.DOWNLOAD_BANK_STATEMENT_TEMPLATE);
      const export_report_path = data?.data?.file;
      const response = await fetch(
        export_report_path,
        {
          method: "GET",
        },
      );
 
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
 
      const fileName = export_report_path.split("/").pop() || "download.csv";
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName; // Force download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleImportModal = async () => {
    setShowImport(!showImport);
  };

  const handleExcelClose = () => {
    setExcelSelectedRow([]);
    setShowExcelModal(false);
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleImportClose = () => {
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleClose = () => {
    setFiles([]);
  };

  const ExcelAccountColumns = [
    // {
    //   dataField: "account",
    //   text: "Account",
    //   editCellClasses: "edit-cell-excel-class",
    //   editor: {
    //     type: Type.SELECT,
    //     options: accountingList,
    //   },
    //   classes: (cell) => {
    //     if (String(cell)?.length === 0) {
    //       return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
    //     } else if (String(cell) === "Select Account") {
    //       return `${TDClasses} text-red-500`;
    //     }
    //     return TDClasses;
    //   },
    //   headerClasses: THClasses,
    // },
    // {
    //   dataField: "type",
    //   text: "Transaction Type",
    //   editCellClasses: "edit-cell-excel-class",
    //   editor: {
    //     type: Type.SELECT,
    //     options: typeList,
    //   },
    //   classes: (cell) => {
    //     if (String(cell)?.length === 0) {
    //       return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
    //     } else if (String(cell) === "Select Type") {
    //       return `${TDClasses} text-red-500 `;
    //     }
    //     return TDClasses;
    //   },
    //   headerClasses: THClasses,
    // },
    {
      dataField: "transaction_date",
      text: "Transaction Date",
      editCellClasses: "edit-cell-excel-class",
      editor: {
        type: Type.DATE,
      },
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell === "string" && cell?.includes("-") && cell) {
          dateObj = cell?.split("-");
          if (dateObj[2]?.length > 2) {
            return `${dateObj[0]}-${dateObj[1]}-${dateObj[2]}`;
          } else {
            return `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
          }
        }
        if (typeof cell !== "object" && cell) {
          var utc_days = Math.floor(cell - 25569);
          var utc_value = utc_days * 86400;
          dateObj = new Date(utc_value * 1000);
        }
        if (cell) {
          return `${("0" + dateObj?.getUTCDate()).slice(-2)}-${(
            "0" +
            (dateObj?.getUTCMonth() + 1)
          ).slice(-2)}-${dateObj?.getUTCFullYear()}`;
        }
      },
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Transaction Date is Required",
          };
        }
        return true;
      },
      classes: (cell) => {
        if (cell === "" || cell === undefined || cell === null) {
          return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
        }
        return TDClasses;
      },
      headerClasses: THClasses,
    },
    {
      dataField: "description",
      text: "Description",
      editCellClasses: "edit-cell-excel-class",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "debit",
      text: "Debit",
      editCellClasses: "edit-cell-excel-class",
      classes: (cell) => {
        return TDClasses;
      },
      headerClasses: THClasses,
      validator: (newValue) => {
        if (String(newValue)?.length === 0) {
          return {
            valid: false,
            message: "Please enter amount",
          };
        }
        return true;
      },
    },
    {
      dataField: "credit",
      text: "Credit",
      editCellClasses: "edit-cell-excel-class",
      classes: (cell) => {
        return TDClasses;
      },
      headerClasses: THClasses,
      validator: (newValue) => {
        if (String(newValue)?.length === 0) {
          return {
            valid: false,
            message: "Please enter amount",
          };
        }
        return true;
      },
    },
    {
      dataField: "balance",
      text: "Balance",
      editCellClasses: "edit-cell-excel-class",
      classes: (cell) => {
        return TDClasses;
      },
      headerClasses: THClasses,
      validator: (newValue) => {
        if (String(newValue)?.length === 0) {
          return {
            valid: false,
            message: "Please enter amount",
          };
        }
        return true;
      },
    },
  ];

  const [excelSelectedRow, setExcelSelectedRow] = useState([]);

  let singleExcelSelectedRows = [];
  let allExcelSelectedRows = [];

  const excelSelectRow = {
    mode: "checkbox",
    clickToSelect: false,
    classes: "selection-row",
    selected: excelSelectedRow,
    nonSelectableClasses: "not-selected-class",
    onSelect: (row, isSelect, rowIndex, e) => {
      singleExcelSelectedRows = [...excelSelectedRow];
      if (isSelect) {
        singleExcelSelectedRows = [...excelSelectedRow, row?.key];
      } else {
        singleExcelSelectedRows.splice(excelSelectedRow.indexOf(row?.key), 1);
      }
      setExcelSelectedRow(singleExcelSelectedRows);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (excelAccountData?.length > 0) {
        if (isSelect) {
          for (let i = 0; i < rows.length; i++) {
            if (excelSelectedRow.includes(rows[i].key)) {
            } else {
              allExcelSelectedRows.push(rows[i].key);
            }
          }
        } else {
          for (let i = 0; i < rows.length; i++) {
            if (excelSelectedRow.includes(rows[i].key)) {
              excelSelectedRow.splice(excelSelectedRow.indexOf(rows[i].key), 1);
            }
          }
        }
        setExcelSelectedRow([...excelSelectedRow, ...allExcelSelectedRows]);
      }
    },
  };

  const excelRef = useRef();

  const dateFormatReader = (value) => {
    var utc_days = Math.floor(value - 25569);
    var utc_value = utc_days * 86400;
    const date = new Date(utc_value * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const ExcelReader = () => {
    let f = files[0];
    const reader = new FileReader();
    let data = null;
    reader.onload = async (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      data = await XLSX.utils.sheet_to_json(ws, { header: 1 });
      /* Update state */
      const businessExcelGenerator = (quantity) => {
        const items = [];
        if (
          String(data[0][0]).replace("*", "") !== "Date" ||
          String(data[0][1]).replace("*", "") !== "Narrative/Description" ||
          String(data[0][2]).replace("*", "") !== "Debit Amount" ||
          String(data[0][3]).replace("*", "") !== "Credit Amount" ||
          String(data[0][4]).replace("*", "") !== "Balance"
        ) {
          setShowExcelModal(false);
          setFiles([]);
          setIsImportLoading(false);

          toast({
            variant: "destructive",
            description:
              "Sorry, File is not in the given format, please download the latest format again",
            duration: 3000,
          });
        } else {
          for (let i = 1; i < quantity; i++) {
            if (data[i].length > 0) {
              let transaction_date =
                typeof data[i][0] === "number"
                  ? dateFormatReader(data[i][0])
                  : data[i][0]?.split("-")[2] > 2
                  ? ExcelDateFormat(data[i][0])
                  : ExcelDateFormat(
                      data[i][0]?.split("-")?.reverse()?.join("-")
                    );
              items.push({
                key: i,
                // account: data[i][0]
                //   ? accountingList.find((item) => item.label === data[i][0])
                //     ? data[i][0]
                //     : "Select Account"
                //   : "Select Account",
                // type: data[i][0]
                //   ? typeList.find(
                //       (item) =>
                //         item.excelData === String(data[i][1]).toLowerCase()
                //     )
                //     ? typeList.find(
                //         (item) =>
                //           item.excelData === String(data[i][1]).toLowerCase()
                //       ).label
                //     : "Select Type"
                //   : "",
                transaction_date:
                  typeof data[i][0] === "string"
                    ? transaction_date?.split("-")?.reverse()?.join("-")
                    : transaction_date
                    ? transaction_date
                    : "",
                description: data[i][1] ? data[i][1] : "",
                debit: data[i][2] ? data[i][2] : "",
                credit: data[i][3] ? data[i][3] : "",
                balance: data[i][4] ? data[i][4] : "",
              });
            }
          }
        }

        return items;
      };
      setExcelAccountData(businessExcelGenerator(data?.length));
    };
    reader.readAsBinaryString(f);
  };

  useEffect(() => {
    showExcelModal && ExcelReader();
    // eslint-disable-next-line
  }, [showExcelModal]);

  const handleExcelModal = () => {
    setShowExcelModal(true);
  };

  const handleUpload = async () => {
    if (files) {
      setShowExcelModal(true);
      const formData = new FormData();

      formData.append("trust_id", trustId);

      let arr = Array.from(new Set(excelSelectedRow));
      for (let i = 0; i < arr.length; i++) {
        let row = excelAccountData.find((item) => item.key === arr[i]);
        // if (row.account) {
        //   if (row.account === "Select Account") {
        //     row.account = "";
        //     row.account_id = "";
        //   } else {
        //     row.account_id = accountingList?.find(
        //       (item) => item?.label === row?.account
        //     )?.value;
        //   }
        // }
        if (typeof row.transaction_date !== "object") {
          let dueDateTemp = String(row.transaction_date)
            ?.split("T")[0]
            ?.split("-");
          // row.transaction_date = `${dueDateTemp[2]}-${dueDateTemp[1]}-${dueDateTemp[0]}`;
          if (dueDateTemp[2]?.length === 4) {
            row.transaction_date = `${dueDateTemp[0]}-${dueDateTemp[1]}-${dueDateTemp[2]}`;
          } else {
            row.transaction_date = `${dueDateTemp[2]}-${dueDateTemp[1]}-${dueDateTemp[0]}`;
          }
        } else {
          row.transaction_date = moment(
            row?.transaction_date,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
        }
        // if (row.type) {
        //   if (row.type === "Select Type") {
        //     row.type = "";
        //   } else {
        //     row.type = typeList?.find(
        //       (item) => item?.label === row?.type
        //     )?.base_type;
        //   }
        // }
        if (row.description === "") {
          row.description = "";
        }
        // formData.append(`accounts[${i}]`, JSON.stringify(row));
        Object.keys(row).forEach((key) => {
          formData.append(`transactions[${i}][${key}]`, row[key]);
        });
      }

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      try {
        setIsImportLoading(true);
        const { data } = await fileUpload(
          `${API.BANK_STATEMENT_IMPORT}`,
          formData,
          config
        );
        setIsImportLoading(false);
        if (data?.data?.file) {
          const export_report_path = data?.data?.file;
          if (export_report_path) {
            let a = document.createElement("a");
            a.href = export_report_path;
            let file = export_report_path.split("/");
            a.setAttribute(
              "download",
              file[file.length - 1] || "error-chart-of-accounts.xls"
            );
            a.setAttribute("target", "_blank");
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();
          }
        }
        if (data) {
          setExcelSelectedRow([]);
          handleExcelClose();
          fetchAccountData();
          handleImportClose();
        }
        return data?.data;
      } catch (error) {
        setIsImportLoading(false);
      }
    }
  };

  const handleExcelTableChange = async (
    type,
    { data, cellEdit: { rowId, dataField, newValue } }
  ) => {
    const getWithPromiseAll = async () => {
      let temp = await Promise.all(
        data.map(async (row) => {
          if (row?.key === rowId) {
            const newRow = { ...row };
            // if (dataField === "account") {
            //   let accountValue = accountingList?.find(
            //     (item) => item?.value === newValue
            //   );
            //   newRow[dataField] = accountValue
            //     ? accountValue?.label
            //     : "Select Account";
            // } else {
            newRow[dataField] = newValue;
            // }

            return newRow;
          }
          return row;
        })
      );
      return temp;
    };
    const result = await getWithPromiseAll();
    setExcelAccountData(result);
  };
  return (
    <>
      <div className="flex bg-webPrimary rounded-md">
        <AnimatedTooltip title={"Import Bank Transactions"} bottomAlign>
          <Button
            onClick={handleImportModal}
            className="bg-transparent flex items-center gap-1 px-2"
          >
            <FileSpreadsheet size={18} />
            {ButtonName}
          </Button>
        </AnimatedTooltip>
        <AnimatedTooltip title={"Download Template"} bottomAlign>
          <Button
            onClick={() => handleDownload()}
            className="bg-transparent border-l border-white dark:border-black rounded-ss-none rounded-es-none px-2 rounded-se-md rounded-ee-md"
          >
            <Download size={18} />
          </Button>
        </AnimatedTooltip>
      </div>
      <ResponsiveDrawerForm
        description={""}
        title={"Import Bank Transactions"}
        handleOpen={() => {}}
        handleClose={() => {
          handleClose();
        }}
        popupType={"bank-transactions"}
        className={"sm:max-w-1/2"}
        open={showImport}
        buttonClassName={""}
        setOpen={setShowImport}
        mobileCancelHidden={true}
        write={true}
      >
        <>
          <FileUpload
            files={files}
            setFiles={setFiles}
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
          />

          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              onClick={(e) => {
                handleExcelModal();
              }}
              disabled={files?.length === 0}
            >
              Upload
            </Button>
            <Button
              className="reset ml-3"
              data-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                handleImportClose();
              }}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </>
      </ResponsiveDrawerForm>
      <ResponsiveDrawerForm
        description={""}
        title={"Upload Excel"}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"max:min-w-screen"}
        open={showExcelModal}
        buttonClassName={""}
        setOpen={setShowExcelModal}
        write={true}
        popupType={"bank-transactions"}
      >
        <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
          {isImportLoading && <Spin full expand={true} fullscreen={true}/>}
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              selectRow={excelSelectRow}
              ref={excelRef}
              remote={{ cellEdit: true }}
              data={excelAccountData ? excelAccountData : []}
              columns={ExcelAccountColumns}
              noDataIndication="No Data Found"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                timeToCloseMessage: 30000,
              })}
              onTableChange={handleExcelTableChange}
              rowClasses={TRClasses}
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
          <div className="pt-4 border-t mt-4 flex items-center justify-between">
            <div>Selected Records: {excelSelectedRow?.length}</div>
            <Button
              onClick={handleUpload}
              data-toggle="modal"
              data-target="#business"
              disabled={excelSelectedRow.length === 0 ? true : false}
            >
              Import
            </Button>
          </div>
        </div>
      </ResponsiveDrawerForm>
    </>
  );
};

export default UploadBankTransaction;
